import styled from 'styled-components';

export const Container = styled.div`

    & {
        width: 100%;

        display: flex;
        flex-direction: row;

        flex-wrap: wrap;
        justify-content: center;
        z-index: 0;
    }

`;
